export default "__VITE_ASSET__mqsbCCcb__"